<template>
	<div ref="chart" class="analytics_pie_chart"></div>
</template>

<script>
import Plotly from 'plotly.js-dist';

export default {
	name: 'SectionsAnalyticsPieChart',
	props: {
		labels: {
			type: Array,
			required: true,
		},
		values: {
			type: Array,
			required: true,
		},
		title: {
			type: String,
			default: '',
		},
	},
	mounted() {
		this.renderChart();
		this.$watch(
			() => [this.labels, this.values, this.title],
			() => this.renderChart(),
		);
	},
	beforeUnmount() {
		if (this.$refs.chart) {
			Plotly.purge(this.$refs.chart);
		}
	},
	methods: {
		renderChart() {
			const element = this.$refs.chart;
			if (!element || !this.labels.length) {
				return;
			}

			Plotly.newPlot(
				element,
				[{
					type: 'pie',
					labels: this.labels,
					values: this.values,
					textinfo: 'label+percent',
					hoverinfo: 'label+value+percent',
					textposition: 'inside',
					insidetextorientation: 'radial',
				}],
				{
					title: this.title ? { text: this.title, font: { size: 13 } } : null,
					showlegend: false,
					height: 260,
					margin: { t: this.title ? 36 : 10, b: 10, l: 10, r: 10 },
				},
				{
					responsive: true,
					displayModeBar: false,
				},
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.analytics_pie_chart {
	width: 100%;
	min-height: 260px;
}
</style>
